import { Injectable } from '@angular/core';
import { ProfileEntity } from '@meplis/common';
import { Observable, of, tap } from 'rxjs';
import { ApiProfileV3Service } from '../api/api-profile-v3.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private _profile: ProfileEntity;

  constructor(private _apiProfileV3: ApiProfileV3Service) {}

  private _loadProfile(): Observable<ProfileEntity> {
    return this._apiProfileV3
      .getProfile()
      .pipe(tap((profile) => (this._profile = profile)));
  }

  public getProfile(): Observable<ProfileEntity> {
    if (this._profile) {
      return of(this._profile);
    } else {
      return this._loadProfile();
    }
  }
}
